import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import { Toaster } from 'sonner';
import { ConfirmProvider } from '../components/confirm-dialog';

export function Providers({ children }: PropsWithChildren) {
  const [client] = useState(() => new QueryClient());
  return (
    <QueryClientProvider client={client}>
      {/* useConfirm(): in-app confirm/reason dialogs for destructive actions. */}
      <ConfirmProvider>{children}</ConfirmProvider>
      {/* Toasts — design system v2 §08: ink-900 surface, tinted status icon,
          haldi action. Colours live in index.css (`[data-sonner-toaster]`). */}
      <Toaster position="bottom-center" closeButton={false} />
    </QueryClientProvider>
  );
}
